var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.71,
    height: 12.71,
    viewBox: "0 0 12.71 12.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(-635.77 -1129.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8032",
    "data-name": "Group 8032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18062",
    "data-name": "Path 18062",
    d: "M642.125,1142.545a1,1,0,0,1-1-1v-10.71a1,1,0,0,1,2,0v10.71A1,1,0,0,1,642.125,1142.545Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8033",
    "data-name": "Group 8033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18063",
    "data-name": "Path 18063",
    d: "M647.48,1137.19H636.77a1,1,0,0,1,0-2h10.71a1,1,0,0,1,0,2Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e4799957810016d5cd41e8d1d50159b4.svg";
export { ForwardRef as ReactComponent };